<template>
  <div
    class="flex input-select"
    style="cursor: pointer"
    v-on-clickaway="closeSelect" >
    <label
      v-if="label"
      class="m-r-5 bold"
      style="align-items: flex-start; width: auto; display: flex; font-size: 15px;margin-bottom: 0;line-height: inherit"
      @click="closeSelect">
      {{ label }} <span v-if="rules.required" class="warning-color">*</span>
    </label>
    <div
      :class="{required: shouldShowError}"
      @click="openListOnClick"
      style="font-size: 15px"
      class="flex bold"
      tabindex="0"
      @focus="openListOnFocus">
      <span v-if="cmpTextValue.text === ''">{{ $t('select') }}</span>
      <span v-else
        :class="['',
          (darkText ? 'dark-text':''),
          ((countryFlag && cmpTextValue != '') ? 'cut-text-calc' : 'cut-text'),
        ]">
        {{ shouldTranslate ? $t(cmpTextValue.text) : cmpTextValue.text }}
      </span>
      <Icon
        style="position: inherit;display: flex"
        class="icon"
        name="arrowDown"
        size="20" />
    </div>
    <div
      v-show="isListOpened"
      :class="listPosition"
      class="options-list"
      ref="selectReference">
      <ul>
        <li
          @keydown.prevent="nextItem"
          tabIndex="-1"
          v-for="(item, index) in filteredList"
          :key="`option-${index}`"
          :class="{active: indexItem === index}"
          :ref="`${randomSelectId}-${index}-opt`"
          @click.prevent="setValue(item.value)">
          {{ shouldTranslate ? $t(item.text) : item.text }}
          <input :value="item.value" type="checkbox" style="display: none;"/>
        </li>
      </ul>
    </div>
    <span v-if="shouldShowError" class="warning-color validation-span" style="font-size: 12px;">{{ $t(errorMsg) }} {{ errorMsgAdditional }}</span>
  </div>
</template>

<script>
/* eslint-disable */
import { directive as onClickaway } from 'vue-clickaway';
import CountryFlag from 'vue-country-flag';
import Checkbox from '@/components/elements/inputs/checkbox';
import rules from "@/mixins/rules";

export default {
  name: 'TextSelect',
  mixins: [rules],
  directives: {
    onClickaway: onClickaway,
  },
  components: {
    CountryFlag, Checkbox,
  },
  props: {
    shouldTranslate: {
      type: Boolean,
      default: true,
    },
    log: {
      type: Boolean,
      default: false,
    },
    parentContainerHeight: {
      type: [String, Number],
      default: '0',
    },
    options: {
      type: Array,
      default: function () {
        return [];
      },
    },
    darkText: {
      type: Boolean,
      default: false,
    },
    countryFlag: {
      type: Boolean,
      default: false,
    },
    renderCustomText: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Select option',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, String, Boolean, Array],
      default: '',
    },
    showSearch: {
      type: Number,
      default: 7,
    },
    showAllButtons: {
      type: Number,
      default: 3,
    },
    preselected: {
      type: Array,
      deafult: () => {
        return [];
      },
    },
  },
  data() {
    return {
      indexItem: 0,
      isListOpened: false,
      openedOnClick: false,
      search: '',
      listPosition: 'bottom',
    };
  },
  computed: {
    filteredList() {
      if(this.options.length < 1) return [];
      let selectedList = this.options.filter(option => {
        if(option.hasOwnProperty('selected')){
          if(!option.selected) return option;
        } else {
          return option;
        }
      });
      return selectedList.filter(option => {
        return option.text.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    cmpTextValue() {
      if(this.value === undefined) return ''; //Ovo prekontrolisi || this.value === null
      if( (this.value !== '') && (this.options.length > 0) ) {
        this.options.filter((opt, index) => {
          if(opt.value == this.value) this.indexItem = index;
        });
        if (!this.options.filter(opt => opt.value == this.value)[0]) {
          return '';
        }
        let text = this.options.filter(opt => opt.value == this.value)[0].text || '';
        if(text === ''){
          return '';
        } else {
          return {
            text: this.options.filter(opt => opt.value == this.value)[0].text,
            countryFlag: this.countryFlag ? this.options.filter(opt => opt.value == this.value)[0].country : '',
          };
        }
      }
      return '';
    },
    randomSelectId() {
      return `select-${this.randomNumber()}`
    },
  },
  methods: {
    nextItem (event) {
      if(event.keyCode == 9) this.closeSelect();
    	if (event.keyCode == 38 && this.indexItem > 0) {
      	this.indexItem--;
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      } else if (event.keyCode == 40 && this.indexItem < this.options.length - 1) {
      	this.indexItem++;
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      } else if (event.keyCode == 13) {
      	this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].click();
      }
    },
    randomNumber() {
      return Math.floor(100000 + Math.random() * 900000);
    },
    changeValue(index, option) {
        this.onChange(null, option);
    },
    closeSelect() {
      this.isListOpened = false;
      this.openedOnClick = false;
      this.search = '';
    },
    openListOnClick() {
      if(this.openedOnClick) {
        this.closeSelect();
        return;
      }
      this.isListOpened = true;
      this.openedOnClick = true;
      this.$nextTick(() => {
        if( this.filteredList.length > 0) {
          this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
        }
        if( this.filteredList.length > this.showSearch){
          this.$refs.searchField.focus();
        }
      });
    },
    openListOnFocus() {
      this.isListOpened = true;
      this.$nextTick(() => {
        if( this.filteredList.length > 0) {
          this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
        }
        if( this.filteredList.length > this.showSearch){
          this.$refs.searchField.focus();
        }
      });
    },
    setValue(val) {
      this.$emit('change', val);
      this.$emit('input', val);
      this.closeSelect()
    },
  },
}
</script>
